__turbopack_context__.v({
  "error-message": "omnichannel-chat-block-module-scss-module__fpvF0G__error-message",
  "omnichannel-chat-wrapper": "omnichannel-chat-block-module-scss-module__fpvF0G__omnichannel-chat-wrapper",
});
